const options = [
    {
        content: 0,
        icon: false,
        text: "Nenhuma",
    },
    {
        content: 1,
        icon: false,
        text: "Uma",
    },
    {
        content: 2,
        icon: false,
        text: "Duas",
    },
];

export default options;
